import { get, set } from 'lodash-es'

export default {
  methods: {
    $_filterChips_clearChip({ model }) {
      if (!model) return

      const value = Array.isArray(get(this, model)) ? [] : undefined
      const updatedContext = set(this, model, value)
      Object.assign(this, updatedContext)
    },
  },
}
